import { memo, useCallback } from 'react';
import { Dialog, DialogSurface, DialogBody, DialogTitle, DialogContent, DialogActions, Button } from '@fluentui/react-components';
import { useOtherAllocatedProjects } from '../state';
import { AllocationProjectList } from './AllocationProjectList';

type TotalAllocationDialogProps = {
    open: boolean;
    onClose: () => void;
    onProjectClick?: (projectName: string) => void;
};

export const TotalAllocationDialog = memo(function TotalAllocationDialog({ open, onClose, onProjectClick }: TotalAllocationDialogProps) {
    const otherProjects = useOtherAllocatedProjects();

    const handleProjectClick = useCallback(
        (projectName: string) => {
            onClose();
            onProjectClick?.(projectName);
        },
        [onClose, onProjectClick],
    );

    return (
        <Dialog open={open} onOpenChange={(_e, data) => !data.open && onClose()}>
            <DialogSurface>
                <DialogBody>
                    <DialogTitle>Other allocated projects</DialogTitle>
                    <DialogContent>
                        {otherProjects.length === 0 ? (
                            <span>No other projects with allocations.</span>
                        ) : (
                            <AllocationProjectList onProjectClick={onProjectClick ? handleProjectClick : undefined} />
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button appearance="secondary" onClick={onClose}>
                            Close
                        </Button>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
});
